import { CurrencyMinimalAmount, CurrencyRatesPrecision } from 'models/settings'
import { getRatePrecision } from 'utils/format-number'

export const HIGH_PRECISION_RATE_THRESHOLD = 4
export const HIGH_PRECISION_DEFAULT_BASE_AMOUNT = '1000.00'

interface GetDefaultBaseAmountForPairParams {
  baseCurrency: string
  counterCurrency: string
  exchangeRatePrecision: CurrencyRatesPrecision
  minimalAmounts: CurrencyMinimalAmount[]
  fallbackAmount: string
}

export const getDefaultBaseAmountForPair = ({
  baseCurrency,
  counterCurrency,
  exchangeRatePrecision,
  minimalAmounts,
  fallbackAmount,
}: GetDefaultBaseAmountForPairParams): string => {
  const pair = `${baseCurrency}${counterCurrency}`
  const pairWithSeparator = `${baseCurrency}_${counterCurrency}`
  const pairPrecision = exchangeRatePrecision[pair] ?? getRatePrecision(pairWithSeparator)
  const amount = pairPrecision > HIGH_PRECISION_RATE_THRESHOLD ? HIGH_PRECISION_DEFAULT_BASE_AMOUNT : fallbackAmount

  const minimalAmount = Number(minimalAmounts.find((a) => a.currency === baseCurrency)?.minimal_local || 0)

  if (minimalAmount > Number(amount)) {
    return minimalAmount.toFixed(2)
  }

  return amount
}
